import getGroupRoutedRequestInit from './getGroupRoutedRequestInit';
import { MailboxInfo, MailboxType } from 'owa-client-ids';
import { getRoutingKeyPrefixForSmtpAddress } from 'owa-client-ids';

// Map<groupId, MailboxInfo>
const groupMailboxInfoMap: { [key: string]: MailboxInfo } = {};

export default function getGroupMailboxInfo(groupId: string): MailboxInfo {
    const groupIdKey = groupId.toLocaleLowerCase();
    if (!groupMailboxInfoMap[groupIdKey]) {
        const groupMailboxInfo: MailboxInfo = {
            type: MailboxType.GroupMailbox,
            deprecatedMailboxId: groupId,
            primarySmtpAddress: groupId,
            routingKey: getRoutingKeyPrefixForSmtpAddress() + groupId,
            returnModernConversationItems: false,
            requestOptions: getGroupRoutedRequestInit(groupId),
        };
        groupMailboxInfoMap[groupIdKey] = groupMailboxInfo;
    }

    return groupMailboxInfoMap[groupIdKey];
}
